import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VIcon,_vm._g(_vm._b({attrs:{"color":!['avo', 'avo_master'].includes(_vm.$branding.data.code) ? 'primary' : undefined}},'v-icon',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.icon)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }